@if (visible()) {
  <div class="shell-system-alert" role="alert">
    <img
      class="shell-system-alert__icon"
      src="assets/icons/info-circle-tooltip-blue.svg"
      alt=""
      aria-hidden="true"
      width="16"
      height="16"
    />

    <div class="shell-system-alert__message" [innerHTML]="banner().html"></div>

    <button
      class="shell-system-alert__close"
      type="button"
      [attr.aria-label]="'layout.alert.closeAria' | translate"
      (click)="dismissed.emit()"
    >
      <img
        class="shell-system-alert__close-icon"
        src="assets/icons/close-circle-blue.svg"
        alt=""
        aria-hidden="true"
        width="16"
        height="16"
      />
    </button>
  </div>
}
